/* Modulo Trust Strip — mobile scroll-snap carousel with dot pagination.
   Desktop = static grid (no JS movement). Vanilla, reduced-motion aware.
   Sections can't use window.moduloLazyInit (extension-only) — init directly. */
(function () {
  'use strict';

  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initTrack(track) {
    if (!track || track.dataset.tsInit === '1') return;

    var items = Array.prototype.slice.call(track.querySelectorAll('.modulo-ts__item'));
    if (items.length < 2) return;

    var container = track.parentElement;
    var dotsHost = container ? container.querySelector('[data-ts-dots]') : null;

    track.dataset.tsInit = '1';

    function step() {
      var first = items[0];
      if (!first) return 0;
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function activeIndex() {
      var s = step();
      if (s <= 0) return 0;
      return Math.max(0, Math.min(items.length - 1, Math.round(track.scrollLeft / s)));
    }

    function syncDots() {
      if (!dotsHost) return;
      var idx = activeIndex();
      var dots = dotsHost.children;
      for (var i = 0; i < dots.length; i++) {
        var on = i === idx;
        dots[i].classList.toggle('is-active', on);
        if (on) dots[i].setAttribute('aria-current', 'true');
        else dots[i].removeAttribute('aria-current');
      }
    }

    // ─── Build dots (one per item) ───
    if (dotsHost) {
      while (dotsHost.firstChild) dotsHost.removeChild(dotsHost.firstChild);
      for (var i = 0; i < items.length; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('aria-label', 'Show promise ' + (i + 1));
        if (i === 0) {
          btn.className = 'is-active';
          btn.setAttribute('aria-current', 'true');
        }
        (function (idx) {
          btn.addEventListener('click', function () {
            track.scrollTo({ left: step() * idx, behavior: REDUCE ? 'auto' : 'smooth' });
          });
        })(i);
        dotsHost.appendChild(btn);
      }
    }

    // ─── Sync active dot on scroll (rAF-throttled) ───
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        syncDots();
        ticking = false;
      });
    }, { passive: true });

    // expose syncer for the shared resize handler (no per-track window listener → no leak)
    track._tsSync = syncDots;

    syncDots();
  }

  function bootstrap() {
    var tracks = document.querySelectorAll('[data-ts-carousel]');
    for (var i = 0; i < tracks.length; i++) initTrack(tracks[i]);
  }

  // Re-sync all strips on resize (breakpoint change flips grid ⇄ carousel)
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var tracks = document.querySelectorAll('[data-ts-carousel]');
      for (var i = 0; i < tracks.length; i++) {
        if (tracks[i]._tsSync) tracks[i]._tsSync();
      }
    }, 100);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  // Theme editor: section re-rendered → re-init its (fresh) track
  document.addEventListener('shopify:section:load', function (e) {
    var scope = (e && e.target) || document;
    var tracks = scope.querySelectorAll
      ? scope.querySelectorAll('[data-ts-carousel]')
      : [];
    for (var i = 0; i < tracks.length; i++) initTrack(tracks[i]);
  });
})();
